import React from 'react';

const SlideOverMenu = ({ isOpen, onClose, onNavigate, currentView }) => {
  const menuItems = [
    { id: 'landing', label: 'Home', icon: '○' },
    { id: 'conversation', label: 'Start a Conversation', icon: '◦' },
    { id: 'sessions', label: 'Past Conversations', icon: '◦' },
    { id: 'about', label: 'About', icon: '◦' },
    { id: 'settings', label: 'Settings', icon: '◦' },
  ];

  const handleItemClick = (id) => {
    onNavigate(id);
    onClose();
  };

  return (
    <>
      <div
        className={`slide-over-overlay ${isOpen ? 'visible' : ''}`}
        onClick={onClose}
        data-testid="menu-overlay"
      />
      
      <div
        className={`slide-over ${isOpen ? 'open' : ''}`}
        data-testid="slide-over-menu"
      >
        <div className="flex flex-col h-full p-8 custom-scroll overflow-y-auto">
          <div className="mb-8">
            <h2 
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: '22px',
                fontWeight: 300,
                fontStyle: 'italic',
                color: 'rgba(255, 243, 225, 0.7)',
                marginBottom: '12px'
              }}
            >
              eunoia
            </h2>
            <div className="humane-seal">
              <div className="humane-seal-icon">◯</div>
              <span>Humane AI</span>
            </div>
          </div>

          <nav className="flex-1 space-y-1">
            {menuItems.map(item => (
              <button
                key={item.id}
                onClick={() => handleItemClick(item.id)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  background: currentView === item.id ? 'rgba(196, 137, 74, 0.1)' : 'transparent',
                  color: currentView === item.id ? 'rgba(255, 243, 225, 0.7)' : 'rgba(255, 243, 225, 0.4)',
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '14px',
                  letterSpacing: '0.05em',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                data-testid={`menu-${item.id}`}
              >
                <span style={{ marginRight: '12px', opacity: 0.5 }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </nav>

          <div style={{ margin: '24px 0', height: '1px', background: 'rgba(255, 243, 225, 0.06)' }} />

          <button
            onClick={() => {
              localStorage.removeItem('auth_token');
              onNavigate('login');
              onClose();
            }}
            style={{
              width: '100%',
              textAlign: 'left',
              padding: '12px 16px',
              background: 'transparent',
              border: 'none',
              color: 'rgba(255, 243, 225, 0.3)',
              fontFamily: "'Inter', sans-serif",
              fontSize: '13px',
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            data-testid="menu-logout"
          >
            Log out
          </button>

          <p 
            style={{
              fontSize: '11px',
              color: 'rgba(255, 243, 225, 0.15)',
              textAlign: 'center',
              marginTop: '24px'
            }}
          >
            v1.0.0
          </p>
        </div>
      </div>
    </>
  );
};

export default SlideOverMenu;
